
export const BGCOLOR = "#D5FFE9";
export const PRIMARY_COLOR = '#44AF69';
export const SECONDRY_COLOR = 'teal';
export const TEXT_COLOR = '#FFFFFF';
export const TEXT_TITLE_COLOR = '#1A6939';
export const WHITE = '#FFFFFF'

export const HIDDEN_BORDER = '1px solid transparent';
export const BORDER = '1px solid black';

// export const COLOR1 = '#0E9594'
// export const COLOR2 = '#FFFFFF'
export const COLOR1 = 'black'
export const COLOR2 = '#FFFFFF'
export const COLOR3 = 'COLOR3'
// export const
// export const
// export const
// export const
// export const
// export const